import { ContainerIterator } from "../../ContainerBase";
import $checkWithinAccessParams from "../../../utils/checkParams.macro";
import { throwIteratorAccessError } from "../../../utils/throwError";
export class RandomIterator extends ContainerIterator {
    /**
     * @internal
     */
    constructor(index, size, getElementByPos, setElementByPos, iteratorType) {
        super(iteratorType);
        this._node = index;
        this._size = size;
        this._getElementByPos = getElementByPos;
        this._setElementByPos = setElementByPos;
        if (this.iteratorType === 0 /* IteratorType.NORMAL */) {
            this.pre = function () {
                if (this._node === 0) {
                    throwIteratorAccessError();
                }
                this._node -= 1;
                return this;
            };
            this.next = function () {
                if (this._node === this._size()) {
                    throwIteratorAccessError();
                }
                this._node += 1;
                return this;
            };
        }
        else {
            this.pre = function () {
                if (this._node === this._size() - 1) {
                    throwIteratorAccessError();
                }
                this._node += 1;
                return this;
            };
            this.next = function () {
                if (this._node === -1) {
                    throwIteratorAccessError();
                }
                this._node -= 1;
                return this;
            };
        }
    }
    get pointer() {
        if (this._node < 0 || this._node > this._size() - 1) {
            throw new RangeError();
        } /**
         * @internal
         */
        return this._getElementByPos(this._node);
    }
    set pointer(newValue) {
        if (this._node < 0 || this._node > this._size() - 1) {
            throw new RangeError();
        } /**
         * @internal
         */
        this._setElementByPos(this._node, newValue);
    }
}
